import FooterSection from "./FooterSection";

export default FooterSection;
